/* eslint-disable no-useless-escape */
export const RULE = {
  EMAIL_OLD: /^[\S]+@[\S]+$/, // Regex use by old logic of forgot-password and login
  EMAIL:
    /^[a-zA-Z0-9._+\-!#$%^&*]+@[a-zA-Z0-9]+(?:[.-][a-zA-Z0-9]+)*\.[a-zA-Z]{2,}$/, // Regex use for new logic
  NUMBER: /^[0-9]*$/,
  DATE: /^[0-9/]+$/,
  JAPANESE: /[一-龠]+|[ぁ-ゔ]+|[ァ-ヴー]+|[ａ-ｚＡ-Ｚ０-９]+|[々〆〤]/,
  PASSWORD: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@#$!%^*?&()\-=_+]{8,}$/,
  OLD_PASSWORD: /^(?=.*[A-Za-z])(?=.*\d).+$/,
}
